import React from 'react';
import { GOOGLE_PLAY_URL } from '../utils/appLinks';
import './AppStoreBadge.css'; // shares the .app-store-badge pill style

/**
 * "Get it on Google Play" badge. Shares the black-pill style with AppStoreBadge.
 * Points at GOOGLE_PLAY_URL from utils/appLinks.js.
 */
const GooglePlayBadge = ({ className = '', onClick }) => (
  <a
    href={GOOGLE_PLAY_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={`app-store-badge ${className}`.trim()}
    onClick={onClick}
    aria-label="Get Canira on Google Play"
  >
    <svg width="20" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M4 3l16 9-16 9V3z" />
    </svg>
    <span className="app-store-badge-text">
      <small>Get it on</small>
      Google Play
    </span>
  </a>
);

export default GooglePlayBadge;
